// extracted by mini-css-extract-plugin
module.exports = {"container":"GetStartedFooter_container__1ghnG"};